var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart flex-column flex-justify-start flex-align-start",class:[{'card-gap': _vm.gap}]},[_c('div',{staticClass:"chart-head flex-row flex-justify-start flex-align-start"},[_vm._v("水量")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-contain flex-row flex-justify-center flex-align-start"},[_c('div',{staticClass:"chart-area",attrs:{"id":"waterref"}})])
}]

export { render, staticRenderFns }